/**
 * Copy för bankpresentationen.
 *
 * Hålls skild från animationen med flit: blandas de två formas prosan av vad som
 * råkar vara lätt att animera i stället för av vad som är sant.
 *
 * Inga påståenden om kunder, spridning eller resultat förekommer här — sådant finns
 * inte och får inte hittas på. Siffrorna nedan beskriver vad en vy visar, aldrig hur
 * många som använder den.
 */

export const KONTON = [
    { id: 'transaktion', namn: 'Transaktionskonto', bokförings: '1930', saldo: 842150 },
    { id: 'spar', namn: 'Sparkonto', bokförings: '1940', saldo: 1250000 },
    { id: 'placering', namn: 'Placeringskonto', bokförings: '1941', saldo: 480000 },
    { id: 'avsattning', namn: 'Yttre fond', bokförings: '1942', saldo: 316400 }
];

export const TRANSAKTIONER = [
    { id: 't1', datum: '4 sep', referens: 'Fortum Markets', belopp: -18420, motpart: 'El, september' },
    { id: 't2', datum: '3 sep', referens: 'Avgift lgh 1102', belopp: 4850, motpart: 'Månadsavgift' },
    { id: 't3', datum: '3 sep', referens: 'Avgift lgh 1103', belopp: 5210, motpart: 'Månadsavgift' },
    { id: 't4', datum: '2 sep', referens: 'Stockholm Vatten', belopp: -9075, motpart: 'VA, augusti' },
    { id: 't5', datum: '1 sep', referens: 'Räntebetalning', belopp: -41300, motpart: 'Fastighetslån' }
];

export const REPRESENTATIONER = [
    {
        nyckel: 'banktransaktion',
        etikett: 'Banktransaktion',
        rubrik: 'Så som banken ser den',
        rader: [
            ['Bokförd', '2026-09-04'],
            ['Referens', 'Fortum Markets AB'],
            ['Belopp', '−18 420,00 kr'],
            ['Konto', 'Transaktionskonto · 1930']
        ]
    },
    {
        nyckel: 'affarshandelse',
        etikett: 'Affärshändelse',
        rubrik: 'Så som föreningen ser den',
        rader: [
            ['Beskrivning', 'Elförbrukning september'],
            ['Typ', 'Leverantörsfaktura'],
            ['Motpart', 'Fortum Markets AB'],
            ['Underlag', 'Faktura 900412-3.pdf']
        ]
    },
    {
        nyckel: 'verifikation',
        etikett: 'Verifikation',
        rubrik: 'Så som bokföringen ser den',
        rader: [
            ['5310 El', '14 736,00 debet'],
            ['2641 Ingående moms', '3 684,00 debet'],
            ['1930 Bank', '18 420,00 kredit'],
            ['Verifikationsnr', 'A 214']
        ]
    }
];

export const KÄLLOR = [
    {
        id: 'psd2',
        etikett: 'Bankkoppling',
        under: 'Hämtas varje natt',
        text: 'Föreningen kopplar sina konton en gång. Därefter hämtas nya transaktioner automatiskt varje natt, och du får veta när en koppling behöver förnyas.'
    },
    {
        id: 'fil',
        etikett: 'Kontoutdrag',
        under: 'CSV från banken',
        text: 'Går banken inte att koppla laddar du upp kontoutdraget i stället. Samma transaktioner, samma dubblettkontroll, samma flöde vidare.'
    }
];
